import React, { useState } from 'react';
import CourseItem from './Components/CourseItem.jsx';
import { Modal, Button, Form } from 'react-bootstrap';
import emailjs from '@emailjs/browser';

import "./css/styles.css"
import "./css/Montserrat.css"
import "./css/Roboto.css"
import "./js/scripts.js"

import HeroCarousel from './Components/HeroCarousel.jsx'
import NavBar from './Components/NavBar.jsx'
import AboutUs from './Pages/AboutUs.jsx'
import CardItem from './Components/CardItem.jsx';
import ClientSlider from './Components/ClientSlider.jsx';
import Contact from './Pages/Contact.jsx';
import Testimony from './Pages/Testimony.jsx';

const courseData = [
  { image: '/courses/situational_leadership.jpeg', heading: 'Situational Leadership', hoverText: 'Mampu menjadi Leader yang dapat menyesuaikan dengan situasi serta kondisi staff.' },
  { image: '/courses/leadership_challenge.jpeg', heading: 'Leadership Challenge', hoverText: 'Memahami peran sebagai Leader, sehingga dapat mengoptimalkan perannya dalam mengelola team.' },
  { image: '/courses/transformation_leadership.jpeg', heading: 'Transformation Leadership', hoverText: 'Research-based assessments are central to The Leader As Coach™ Program. Participants receive quantifiable, reliable 360° feedback on their leadership effectiveness using our widely acclaimed instrument, the LPI.' },
  { image: '/courses/leading_with_passion.jpeg', heading: 'Leading With Passion', hoverText: 'Memiliki motivasi dalam melakukan tugasnya sebagai Leader, sehingga mampu menghadapi tantangan dalam mengelola team.' },
  { image: '/courses/coaching_and_mentoring.jpeg', heading: 'Coaching And Mentoring', hoverText: 'Mampu melakukan teknik coaching dan juga monitoring yang tepat, untuk mengembangkan team.' },
  { image: '/courses/managerial_skill.jpeg', heading: 'Managerial Skill', hoverText: 'Memaknai peran sebagai Supervisor OR manager dengan tepat, sehingga dapat menyesuaikan perilaku yang diharapkan.' },
  { image: '/courses/public_speaking.jpeg', heading: 'Public Speaking', hoverText: 'Mampu melakukan teknik yang tepat dalam berkomunikasi di depan publik.' },
  { image: '/courses/influencing_other_with_communication.jpeg', heading: 'Influencing Other With Communication', hoverText: 'Memahami cara berkomunikasi yang tepat sehingga dapat mempengaruhi lawan bicara.' },
  { image: '/courses/design_thinking.jpeg', heading: 'Design Thinking', hoverText: 'Memanfaatkan alat bantu untuk dapat menciptakan inovasi yang sesuai dengan kebutuhan user.' },
  { image: '/courses/creative_problem_solving_and_decision_making.jpeg', heading: 'Creative Problem Solving And Decision Making', hoverText: 'Secara kreatif menemukan akar masalah dan menyampaikan solusi yang tepat, sehingga dapat menyelesaikan permasalahan yang dihadapi.' },
  { image: '/courses/leading_service_culture.jpeg', heading: 'Leading Service Culture', hoverText: 'Merencanakan budaya layanan dalam sebuah organisasi, sehingga layanan dapat disampaikan serentak oleh seluruh bagian,baik kepada internal maupun eksternal customer.' },
  { image: '/courses/business_presentation_skill.jpeg', heading: 'Business Presentation Skill', hoverText: 'Menyampaikan produk dengan tepat dan menarik bagi customer.' },
];


const logoImagesRight = [
  '/client/logo1.png',
  '/client/logo2.png',
  '/client/logo3.png',
  '/client/logo4.png',
  '/client/logo7.png',
  '/client/logo8.png',
  '/client/logo9.png',
  '/client/logo12.png',
  '/client/logo13.png',
  '/client/logo14.png',
  '/client/logo15.png',
  '/client/logo16.png',
  '/client/logo19.png',
  '/client/logo21.png',
  '/client/logo24.png',
  '/client/logo25.png',
  '/client/logo26.png',
  '/client/logo46.png',
];

const logoImagesLeft = [
  '/client/logo27.png',
  '/client/logo28.png',
  '/client/logo30.png',
  '/client/logo31.png',
  '/client/logo32.png',
  '/client/logo33.png',
  '/client/logo34.png',
  '/client/logo35.png',
  '/client/logo36.png',
  '/client/logo38.png',
  '/client/logo39.png',
  '/client/logo40.png',
  '/client/logo41.png',
  '/client/logo42.png',
  '/client/logo43.png',
  '/client/logo45.png',
  '/client/logo47.png',
  '/client/logo49.png',
  '/client/logo50.png',
];

const ourTeam = [
  {
    image: "/teams/Hidayat.png",
    title: "Hidayat Yusuf",
    tagline: "Senior Consultant",
    body: ""
  },
  {
    image: "/teams/JorisDeFretes.png",
    title: "Joris De Fretes",
    tagline: "Associate",
    body: ""
  },
  {
    image: "/teams/AMLilik.png",
    title: "A. M. Lilik Agung",
    tagline: "Managing Partner",
    body: ""
  }
];
const testimonials = [
  {
    name: "Tri Budi Ambarsari",
    major: "HEAD HUMAN CAPITAL",
    image: "/testimonials/tri_budi.jpeg",
    detail:
      "Saya berkesempatan mengikuti program Leadership, Coaching, dan Communication dari Master Leadership bersama Ibu Shaheena, yang memberikan dampak signifikan bagi pengembangan profesional saya di bidang Human Capital. Program ini dirancang sangat praktis, relevan, dan langsung dapat diaplikasikan, dengan pendekatan coaching yang mendalam serta membuka potensi diri secara optimal. Hasilnya, kemampuan kepemimpinan, komunikasi, dan kepercayaan diri meningkat secara nyata dan terukur. Saya sangat merekomendasikan program ini bagi organisasi yang ingin membangun pemimpin yang lebih agile, komunikatif, dan berdampak tinggi."
  },
  {
    name: "Deki Andika",
    major: "LEGAL COUNSEL OF PT COCA-COLA DISTRIBUTION INDONESIA",
    image: "/testimonials/deki_andika.jpeg",
    detail:
      "Training yang luar biasa dari Shaheena bersama Master Leadership, sangat relevan dengan kebutuhan dunia kerja saat ini dan memberikan dampak yang nyata. Program ini tidak hanya membuka wawasan, tetapi juga meningkatkan kemampuan secara praktis dan aplikatif."
  },
  {
    name: "Anung Priambodo",
    major: "FUNCTION HEAD PEOPLE DEVELOPMENT OF PT NIPPON INDOSARI CORPINDO TBK",
    image: "/testimonials/anung_priambodo.jpeg",
    detail:
      "Mengadakan pelatihan yang tepat sasaran selalu menjadi tantangan, tetapi Trainer Shaena berhasil mengeksekusinya dengan cemerlang. Dimulai dari penggalian kebutuhan (TNA) yang mendalam, modul yang dibawakan sukses dikustomisasi agar relevan dengan kebutuhan karyawan kami. Delivery methodology-nya sangat baik, terbukti dari evaluasi peserta yang memuaskan dan tingkat pemahaman materi yang meningkat drastis. Yang paling membuat saya bangga adalah komitmen after-training-nya; terdapat proses coaching dan mentoring yang memastikan ilmu benar-benar diterapkan. Kini, perubahan perilaku positif dari peserta pasca-pelatihan sudah terlihat nyata. Sangat direkomendasikan!"
  },
  {
    name: "Rizky Fajar Prasetyo",
    major: "",
    image: "/testimonials/rizky_fajar.jpeg",
    detail:
      "Pelatihan coaching ini memberi perspektif baru bagi saya sebagai pegawai. Saya jadi memahami bahwa membangun kinerja tidak cukup hanya dengan target dan arahan, tetapi juga melalui percakapan yang mampu mengembangkan manusia. Saya merasakan bahwa coaching membantu saya membangun hubungan yang lebih kuat dengan tim, meningkatkan kualitas komunikasi dua arah, dan menciptakan ruang yang lebih aman bagi pegawai untuk berpikir, bertumbuh, dan berkontribusi"
  },
  {
    name: "Mohamad Zuhroni",
    major: "Manager HC Business Partner Pertamina",
    image: "",
    detail:
      "Thank you for creating such a fun and warm learning atmosphere in every session. The way you deliver the material makes me feel comfortable to learn and confident to try. I’ve become much more enthusiastic in joining the sessions, and most importantly, my confidence in communicating in English has significantly improved."
  },
  {
    name: "Evy Indahwaty",
    major: "PRESIDENT DIRECTOR OF PT RADANA BHASKARA FINANCE TBK",
    image: "",
    detail:
      "Saya mengenal Master Consultant's sejak lebih 15 tahun lalu, dimana saya sudah 3 kali ditempat perusahaan yang berbeda, saya selalu meminta Ibu Shaheena/Master Consultant's Training untuk memberikan training kepada karyawan karena saya merasakan trainingnya berbobot dan sangat menyesuaikan dengan apa yang saya perlukan.\nMetode training dan materi selalu di-update, tidak hanya dengan situasi kondisi perusahaan tetapi selalu dengan Ilmu - ilmu baru. Apalagi di Era VUCA, sangat penting semua diberikan training. Leader in VUCA adalah training yang sangat bagus. Materi berbobot dan mudah dimengerti.Banyak sharing, diskusi, dan melibatkan audience sehingga setelah training peserta bisa langsung praktik. Master Consultant's juga memberikan input tentang peserta dan melakukan evaluasi setelah itu. Ini yang membuat berbeda dengan yang lain. Terima kash Master Consultant's."
  },
  {
    name: "Endang Hoyaranda",
    major: "COMMISSIONER & PRESIDENT DIRECTOR OF PT PRODIAUTAMA",
    image: "",
    detail:
      "Keeping your team in a highly motivated spirit, is critical to your team success. Master Consulting has successfully supported Prodia Group to come up with new ideas for leadership and training methods, which our team enjoyed tremendously. \nThey went back to work with the significant confidence to move forward in a better way, as leaders and team members. \nOne strong point in the method is the follow up assessments which has become a motivation to the trainees to implement the knowledge and skill in their real work. We did have gained a new partner since knowing Master Consultants."
  },
  {
    name: "Andus Winarno, SE, MH",
    major: "STAFF AHLI BIDANG INDUSTRI BUMN KEMENTRIAN",
    image: "",
    detail:
      "It is my sincere honors to recommend Ms. Shaheena Nazir as an outstanding English trainer. I had the privilege of joining her 12-session program designed to enhance professional English communication, and I must say it has made a significant impact on my ability to communicate with clarity and confidence. \nMs. Nazir brings not only her expertise in English training but also a deep understanding of leadership and the critical role communication plays at the senior level. Her sessions are always relevant, practical, and tailored to the needs of professionals, especially those operating in high-stakes environments such as BUMN and other strategic sectors."
  },
  {
    name: "Susi Meyrista Tarigan",
    major: "KEPALA BIRO UMUM DAN KEUANGAN BUMN KEMENTRIAN",
    image: "",
    detail:
      "I am truly honored to write a recommendation for my English teacher, Ms Shaheena, whose dedication, diligence, and deep commitment to personal growth have left a lasting impact on me and her students in my office. \nFrom the very beginning, she has shown an exceptional level of care not just for teaching English, but for shaping her students as individuals. Every lesson is delivered with precision, passion, and purpose. Her teaching is not just about grammar and vocabulary—it's about building confidence, critical thinking, and the drive to become a better version of ourselves in English speaking. \n She is consistent of emphasazing on personal growth. She sees potential even when we don't see it in ourselves and pushes us to dig deeper—not only in our studies but also in understanding our own motivations and values. Her words of encouragement are thoughtful and often exactly what we need to hear. \nI recommend her for any role or opportunity that values education, mentorship, and genuine human growth. She is not only a skilled teacher, but a life-changer."
  },
  {
    name: "Yudi Wibisono",
    major: "DIRECTOR OF OPERATIONS OF PT PERTAMINA TRANS KONTINENTAL",
    image: "",
    detail:
      "The 1-on-1 English Mentoring Program for the Board of Directors represents a strategic initiative in strengthening English communication capabilities across SH IML. \nThe program delivers a structured, interactive, and confidence-building learning experience, supported by highly competent mentor. \nI am pleased to recommend Ms. Shaheena Nazir for her exceptional ability in delivering English training focused on business communication and soft Skills. During the training at Pertamina, I experienced first-hand how her practical approach and effective techniques helped sharpen my presentation and negotiation capabilities in English. Her sessions are well-structured, interactive, and highly relevant to today's professional demands. \nThe content is clear, relevant, and tailored to my professional context. I have seen a tangible improvement in my communication skills, particularly in high-level professional context. \nMs. Shaheena brings not only deep expertise but also an engaging teaching style that builds both confidence and competence. For professionals or organizations aiming to elevate their communication standards, she is an excellent choice."
  }
];


function App() {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: ''
  });
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleDownloadClick = (e) => {
    e.preventDefault();
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setFormData({ name: '', phone: '', email: '' });
    setFormErrors({});
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error for this field when user starts typing
    if (formErrors[name]) {
      setFormErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const errors = {};

    if (!formData.name.trim()) {
      errors.name = 'Name is required';
    }

    if (!formData.phone.trim()) {
      errors.phone = 'Phone number is required';
    } else if (!/^[0-9+\-\s()]+$/.test(formData.phone)) {
      errors.phone = 'Please enter a valid phone number';
    }

    if (!formData.email.trim()) {
      errors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      errors.email = 'Please enter a valid email address';
    }

    return errors;
  };

  const sendEmailNotification = async (data) => {
    try {
      // EmailJS Configuration
      // To set this up:
      // 1. Create an account at https://www.emailjs.com/
      // 2. Create an email service (Gmail, Outlook, etc.)
      // 3. Create an email template with variables: {{from_name}}, {{phone}}, {{email}}
      // 4. Replace the IDs below with your actual IDs from EmailJS dashboard

      const EMAILJS_SERVICE_ID = 'service_qp2j99f'; // Replace with your EmailJS Service ID
      const EMAILJS_TEMPLATE_ID = 'template_ztav5gg'; // Replace with your EmailJS Template ID
      const EMAILJS_PUBLIC_KEY = 'IBxPIIu_ZJmRAfBYz'; // Replace with your EmailJS Public Key

      const templateParams = {
        from_name: data.name,
        phone: data.phone,
        email: data.email,
        to_email: 'mira@masterleadership.id', // Your notification email
      };

      // Only send email if EmailJS is configured
      if (EMAILJS_SERVICE_ID !== 'YOUR_SERVICE_ID') {
        const response = await emailjs.send(
          EMAILJS_SERVICE_ID,
          EMAILJS_TEMPLATE_ID,
          templateParams,
          EMAILJS_PUBLIC_KEY
        );

        console.log('Email sent successfully:', response);
      } else {
        // Log to console if EmailJS is not configured
        console.log('PDF Download Request:', templateParams);
        console.warn('EmailJS is not configured. Please set up your EmailJS credentials.');
      }

      return { success: true };
    } catch (error) {
      console.error('Email notification error:', error);
      // Continue with download even if email fails
      return { success: false, error };
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    setIsSubmitting(true);

    try {
      // Send email notification
      await sendEmailNotification(formData);

      // Close modal
      handleCloseModal();

      // Trigger PDF download
      const link = document.createElement('a');
      link.href = '/pdf/Materi MasterLeadership.pdf';
      link.download = 'Materi MasterLeadership.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Show success message
      alert('Thank you! Your download will begin shortly.');
    } catch (error) {
      console.error('Submission error:', error);
      alert('An error occurred. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div id="page-top">
      <NavBar />
      {/* Masthead*/}
      <HeroCarousel />
      {/* About*/}
      <section className="page-section" id="about">
        <div className="container">
          <div className="text-center">
            <h2 className="section-heading text-uppercase">About</h2>

          </div>
          <AboutUs />
        </div>
      </section>
      {/* Services*/}
      <section className="page-section bg-light" id="services">
        <div className="container">
          <div className="text-center">
            <h2 className="section-heading text-uppercase">Services</h2>
            <h3 className="section-subheading text-muted">Solusi Yang Kami Tawarkan Dalam Mengembangkan Kompetensi Individu Dan Organisasi</h3>
          </div>
          <div className="row text-center">
            <div className="col-md-3">
              <span className="fa-stack fa-4x">
                <i className="fas fa-circle fa-stack-2x text-primary"></i>
                <i className="fas fa-shopping-cart fa-stack-1x fa-inverse"></i>
              </span>
              <h5 className="my-3">Leadership Training</h5>
              <p className="text-muted">Kepemimpinan merupakan pondasi bagi kesinambungan organisasi, keberhasilan pengembangan kepemimpinan menjadi kunci keberhasilan organisasi.</p>
            </div>
            <div className="col-md-3">
              <span className="fa-stack fa-4x">
                <i className="fas fa-circle fa-stack-2x text-primary"></i>
                <i className="fas fa-laptop fa-stack-1x fa-inverse"></i>
              </span>
              <h5 className="my-3">Management Consulting</h5>
              <p className="text-muted">Setiap organisasi perlu memiliki competitive advantage, manajemen memiliki peranan penting bagi organisasi agar unggul dalam kompetisi.</p>
            </div>
            <div className="col-md-3">
              <span className="fa-stack fa-4x">
                <i className="fas fa-circle fa-stack-2x text-primary"></i>
                <i className="fas fa-lock fa-stack-1x fa-inverse"></i>
              </span>
              <h5 className="my-3">Management Training</h5>
              <p className="text-muted">Mempersiapkan karyawan masuk ke jenjang manajerial sangat krusial untuk kesuksesan individu dan organisasi.</p>
            </div>
            <div className="col-md-3">
              <span className="fa-stack fa-4x">
                <i className="fas fa-circle fa-stack-2x text-primary"></i>
                <i className="fas fa-lock fa-stack-1x fa-inverse"></i>
              </span>
              <h5 className="my-3">Coaching</h5>
              <p className="text-muted">Kemampuan menumbuhkan inner motivation dan sense of purpose dapat menjadi differentiating factor dalam organisasi.</p>
            </div>
          </div>
          <div className="text-center mt-5">
            <button
              type="button"
              onClick={handleDownloadClick}
              className="learn-btn-lg"
            >
              Download now to learn more about our program.
            </button>
          </div>
        </div>
      </section>
      {/* Portfolio Grid*/}
      <section className="page-section" id="portfolio">
        <div className="container">
          <div className="text-center">
            <h2 className="section-heading text-uppercase">Courses</h2>
          </div>
          <div className="row">
            {courseData.map((item, index) => (
              <CourseItem
                key={index}
                image={item.image}
                heading={item.heading}
                hoverText={item.hoverText}
              />
            ))}
          </div>
        </div>
      </section>
      {/* Team*/}
      <section className="page-section bg-light" id="team">
        <div className="container">
          <div className="text-center">
            <h2 className="section-heading text-uppercase">Team</h2>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{
              display: 'flex',
              gap: '1rem',
              padding: '1rem',
              scrollSnapType: 'x mandatory',
              overflowX: 'auto',
            }}>
              {ourTeam.map((card, index) => (
                <CardItem
                  key={index}
                  image={card.image}
                  title={card.title}
                  tagline={card.tagline}
                  body={card.body}
                />
              ))}
            </div>
          </div>

        </div>
      </section>
      {/* Testimony */}
      <section className="page-section" id="testimony">
        <div className="container">
          <div className="text-center">
            <h2 className="section-heading text-uppercase">What Our Clients Say</h2>
          </div>
          <Testimony testimonials={testimonials} />
        </div>
      </section>
      {/* Clients*/}
      <div className="py-5 bg-light">
        <div className="container">
          <ClientSlider images={logoImagesLeft} orientation='left' />
          <ClientSlider images={logoImagesRight} orientation='right' />
        </div>
      </div>
      {/* Contact*/}
      <section className="page-section" id="contact">
        <h2 className="text-center section-heading text-uppercase">Contact Us</h2>
        <Contact />
      </section>

      {/* PDF Download Modal */}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Download Program Information</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-4">Please fill in your details to download our program materials:</p>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Name *</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                isInvalid={!!formErrors.name}
                placeholder="Enter your full name"
              />
              <Form.Control.Feedback type="invalid">
                {formErrors.name}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Phone Number *</Form.Label>
              <Form.Control
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                isInvalid={!!formErrors.phone}
                placeholder="Enter your phone number"
              />
              <Form.Control.Feedback type="invalid">
                {formErrors.phone}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Email Address *</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                isInvalid={!!formErrors.email}
                placeholder="Enter your email address"
              />
              <Form.Control.Feedback type="invalid">
                {formErrors.email}
              </Form.Control.Feedback>
            </Form.Group>

            <div className="d-grid gap-2">
              <Button
                variant="primary"
                type="submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Processing...' : 'Download PDF'}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default App;
